import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';
import { apiWrapper } from '../../api/apiWrapper';

export const thunks = {
  getInvoicesList: createThunk('invoices/getInvoicesList', (values) =>
    apiWrapper.get(WEB_API_ROUTES.invoices.list, {
      params: { ...values },
    })
  ),

  getUserInvoice: createThunk('createInvoice/getUserInvoice', (invoiceId) =>
    api.get(WEB_API_ROUTES.invoices.info.replace('{invoiceId}', invoiceId))
  ),

  getUserInvoiceSchedules: createThunk(
    'createInvoice/getUserInvoiceSchedules',
    (invoiceId) =>
      api.get(
        WEB_API_ROUTES.invoices.schedules.replace('{invoiceId}', invoiceId)
      )
  ),

  sendEmail: createThunk(
    'invoices/sendEmail',
    ({ subject, messageText, messageFor }) =>
      api.post(WEB_API_ROUTES.dancers.email, {
        messageFor,
        subject,
        messageText,
      }),
    'Message sent'
  ),

  sendSms: createThunk(
    'invoices/sendSms',
    ({ messageText, messageFor }) =>
      api.post(WEB_API_ROUTES.dancers.sms, {
        messageFor,
        messageText,
      }),
    'Message sent'
  ),

  deleteInvoice: createThunk('invoices/deleteInvoice', (invoiceId) =>
    api.delete(WEB_API_ROUTES.invoices.info.replace('{invoiceId}', invoiceId))
  ),
};
